import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import ClipboardButton from 'react-clipboard.js';

import iconLink from 'assets/images/icons/icon-link-dark.svg';
import iconCheck from 'assets/images/icons/check-icon.svg';
import Modal from 'components/Modal';

import styles from './ShareDialog.scss';
import { useTranslation } from 'react-i18next';
import Checkbox from '../common/Checkbox';
import { makeBase64, firstLetterToUpper } from '../Building/Main/helper';
import tracker from '../../services/tracker';
import { ROOT_URL } from '../../constants/Config';
import { gaEvent, trackGA } from 'services/ga';

const ShareDialog = ({ onClose, shareId, building, objectType, profile }) => {
  const [showNotification, setShowNotification] = useState(false);
  const [values, setValues] = useState({
    nameAddress: true,
    description: true,
    characteristics: true,
    communications: true,
    checkout: true,
    payment: true,
    lots: true,
  });
  const [url, setUrl] = useState('');
  const [hash, setHash] = useState('');
  const { t } = useTranslation();

  const handleTrackEvent = ({ eventName, eventLabel, eventContent }) => {
    const {
      data: { title, id },
    } = building;
    trackGA(
      gaEvent[eventName]({
        eventLabel,
        eventContent: eventContent || title,
        productType: objectType,
        productName: title,
        productID: id,
        user_id: profile.id,
      })
    );
  };

  useEffect(
    () => () => {
      handleTrackEvent({
        eventName: 'buildingShareButtonsClick',
        eventLabel: 'zakryt',
      });
    },
    []
  );

  const handleInputFocus = (e) => {
    e.target.selectionStart = 0;
    e.target.selectionEnd = e.target.value.length;

    tracker.sendEvent('Web_ShareDialog_Link');
  };

  const handleClipboardClick = () => {
    setShowNotification(true);
    tracker.sendEvent('Web_ShareDialog_CopyButton');

    handleTrackEvent({
      eventName: 'buildingShareButtonsClick',
      eventLabel: 'skopirovat',
    });

    setTimeout(() => this.setState({ showNotification: false }), 5000);
  };

  const handlePdfClick = () => {
    tracker.sendEvent('Web_ShareDialog_SavePdf', {
      id: building.data.id,
      name: building.data.title,
    });

    handleTrackEvent({
      eventName: 'buildingShareButtonsClick',
      eventLabel: 'skachat_prezentaciyu',
    });

    const link = document.createElement('a');
    link.href = `${ROOT_URL}/share-building/pdf/${hash}`;
    link.download = 'file.pdf';
    link.target = '__blank';
    link.dispatchEvent(new MouseEvent('click'));
    link.remove();
  };

  const handleChange = (name, value, text) => {
    tracker.sendEvent(`Web_ShareDialog_${firstLetterToUpper(name)}`, {
      selected: value,
    });

    handleTrackEvent({
      eventName: 'buildingShareCheckboxesPick',
      eventContent: [text, ` | ${value ? 'on' : 'off'}`],
    });

    setValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    makeBase64({
      id: shareId,
      values,
    }).then((hashValue) => {
      setHash(hashValue);
      setUrl(`${window.location.origin}/nbref/${hashValue}`);
    });
  }, [values]);

  return (
    <Modal
      isOpen
      handleClose={onClose}
      title={t('components.shareDialog.sendObject')}
      contentStyle={{
        width: '583px',
        margin: 'auto',
      }}
    >
      <div className={styles.Modal}>
        <p className={styles.ModalDescription}>{t('components.shareDialog.title')}</p>
        <div className={styles.ModalCheckboxes}>
          <Checkbox
            checked={values.nameAddress}
            handle={(value) => handleChange('nameAddress', value, 'Название и адрес')}
            text={t('components.shareDialog.nameAndAddress')}
          />
          <Checkbox
            checked={values.description}
            handle={(value) => handleChange('description', value, 'Описание и преимущества')}
            text={t('components.shareDialog.descriptionAndAdvantages')}
          />
          <Checkbox
            checked={values.characteristics}
            handle={(value) => handleChange('characteristics', value, 'Общие характеристики')}
            text={t('components.shareDialog.mainInfo')}
          />
          <Checkbox
            checked={values.communications}
            handle={(value) => handleChange('communications', value, 'Коммуникации')}
            text={t('components.shareDialog.communications')}
          />
          <Checkbox
            checked={values.checkout}
            handle={(value) => handleChange('checkout', value, 'Оформление')}
            text={t('components.shareDialog.documents')}
          />
          <Checkbox
            checked={values.payment}
            handle={(value) => handleChange('payment', value, 'Оплата')}
            text={t('components.shareDialog.payments')}
          />
          <Checkbox
            checked={values.lots}
            handle={(value) => handleChange('lots', value, 'Лоты')}
            text={t('components.shareDialog.lots')}
          />
        </div>
        <p className={styles.SendLink}>{t('components.shareDialog.hint')}</p>
        <div className={styles.SendCollectionInputWrap}>
          <img src={iconLink} alt="" />
          <input
            readOnly
            value={url}
            className={styles.SendCollectionInput}
            onFocus={handleInputFocus}
          />
        </div>

        <ClipboardButton
          className={cn(styles.SendCollectionBtn, 'button-primary', 'button-primary--sm')}
          data-clipboard-text={url}
          onClick={handleClipboardClick}
        >
          {t('components.shareDialog.copy')}
        </ClipboardButton>

        <button className={cn(styles.SendPdf)} onClick={handlePdfClick}>
          {t('components.shareDialog.savePdfFile')}
        </button>

        {showNotification ? (
          <span className={styles.ModalNotification}>
            <img src={iconCheck} alt={t('components.shareDialog.copied')} />{' '}
            {t('components.shareDialog.copied')}
          </span>
        ) : null}
      </div>
    </Modal>
  );
};

export default React.memo(ShareDialog);



// WEBPACK FOOTER //
// ./src/components/ShareDialog/ShareDialog.js